import React, { Fragment, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUser, FaShoppingBag } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { IoSettings } from "react-icons/io5";
import { MdDeliveryDining } from "react-icons/md";


const sidebarItems = [
  { icon: <FaUser aria-label="Home" />, label: "HOME", path: "/admin" },
  { icon: <FaShoppingBag aria-label="Orders" />, label: "ORDERS", path: "/admin/orders" },
  { icon: <FaShoppingBag aria-label="Brands" />, label: "BRANDS", path: "/admin/brands" },
  { icon: <MdCategory aria-label="Parent Categories" />, label: "PARENT CATEGORIES", path: "/admin/parent-categories" },
  { icon: <MdCategory aria-label="Categories" />, label: "CATEGORY", path: "/admin/categories" },
  { icon: <AiFillProduct aria-label="Products" />, label: "PRODUCT", path: "/admin/products" },
  // { icon: <AiFillProduct aria-label="Offers" />, label: "OFFERS", path: "/admin/offers" },
  { icon: <FaShoppingBag aria-label="Users" />, label: "USERS", path: "/admin/users" },
  { icon: <FaShoppingBag aria-label="Featured Products" />, label: "TOP PICKS", path: "/admin/featured-products" },
  { icon: <FaShoppingBag aria-label="Complimentary Products" />, label: "FREE PRODUCTS", path: "/admin/complimentary-products" },
  { icon: <MdDeliveryDining aria-label="Delivery Partner" />, label: "DELIVERY PARTNER", path: "/admin/delievery-partner" },
  { icon: <FaShoppingBag aria-label="Reports" />, label: "REPORTS", path: "/admin/admin-report" },
  { icon: <IoSettings aria-label="Settings" />, label: "SETTINGS", path: "/admin/settings" },
];

const AdminSidebar = memo(({ onItemClick }) => {
  const location = useLocation();
  const handleItemClick = () => {
    if (onItemClick) {
      onItemClick();
    }
  };

  return (
    <Fragment>
      <div className="admin-sidebar">
        <ul>
          {sidebarItems.map((item, index) => {
            const isHome = item.path === "/admin";
            const isActive = isHome
              ? location.pathname === "/admin"
              : location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <li key={index} className={isActive ? 'active-menu' : ''}>
                {item.icon}
                <Link to={item.path} onClick={handleItemClick}>{item.label}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </Fragment>
  );
});

export default AdminSidebar;
